import http from '../utils/HttpClient';

const get = async (activationCode: string | null) => {
  if (!activationCode || activationCode === 'null' || activationCode === null) {
    return null;
  }

  const url = `images/logo/${activationCode}`;

  const { data } = await http.get(url);

  return data;
};

export default get;
